/@flow/
import React from 'react';
import LocationPicker from 'comps/LocationPicker';
import * as I from 'immutable';
import { useLocals } from 'lib/proforma/hooks';
import Textbox from 'lib/proforma/templates/Textbox';
import type { PathT } from 'lib/proforma/types';

const regex = /(-?\d+(.\d+)?) (-?\d+(.\d+)?)/;

function parseCenter(geom) {
  if (!geom) return;
  const centerRx = geom.match(regex) || [];
  const centerArr = [centerRx[3], centerRx[1]].filter(Boolean);
  let center;
  if (!I.List(centerArr).isEmpty()) {
    center = { lon: parseFloat(centerRx[1]), lat: parseFloat(centerRx[3]) };
  }
  return center;
}

//
//
// NOTE: must be assigned to 'address' field.
//
//
const LocationPickerTemplate: any = Textbox.clone({
  Input: ({ path }: { path: PathT }) => {
    const theGeomPath = I.List(path)
      .butLast()
      .push('theGeom')
      .toArray();

    const idPath = I.List(path)
      .butLast()
      .push('id')
      .toArray();
    const idLocals = useLocals(idPath);
    const geomLocals = useLocals(theGeomPath);
    const addressLocals = useLocals(path);
    const { attrs: theGeomAttrs } = useLocals(theGeomPath);
    const { attrs } = useLocals(path);
    const center = parseCenter(geomLocals.value);

    const onAddressChange = fullAddress => {
      if (fullAddress && addressLocals.value !== fullAddress) {
        addressLocals.onChange(fullAddress);
      }
    };

    const onGeomChange = theGeom => {
      if (theGeom && geomLocals.value !== theGeom) {
        geomLocals.onChange(theGeom);
      }
    };

    return (
      <LocationPicker
        key={idLocals.value}
        name={attrs.name}
        theGeomName={theGeomAttrs.name}
        fullAddress={addressLocals.value}
        theGeom={geomLocals.value}
        center={center}
        onGeomChange={onGeomChange}
        onAddressChange={onAddressChange}
      />
    );
  },
});
export default LocationPickerTemplate;